import * as React from 'react';
import ZoomButtons from './ZoomButtons';
import Grid2400 from '../../assets/images/grid2400.png';

interface IPlanAnnotationDisplayProps {
    canvasId: string;
    setCanvasContainerReference: (node: any) => void;
    zoom: (zoomAmount: number) => void;
    restoreCanvasPosition: () => void;
}

let style = {
    width: '100%',
    backgroundColor: 'gainsboro'
};

const PlanAnnotationDisplay = (props: IPlanAnnotationDisplayProps) => {
    return (
        <div id="annotation-container" style={style}>
            <ZoomButtons zoom={props.zoom} restoreCanvasPosition={props.restoreCanvasPosition} />
            <img src={Grid2400} alt="grid" style={{ display: 'none' }} id="grid2400" />
            <div className="canvas-outer" ref={(node) => props.setCanvasContainerReference(node)}>
                <canvas id={props.canvasId} />
            </div>
        </div>
    );
};

export default PlanAnnotationDisplay;
